import { apiEmpleo } from "../../util/ApiEmpleo";

export const PREFILTER_CANDIDATE_MAX_RESULTS = "PREFILTER_CANDIDATE_MAX_RESULTS";
export const PREFILTER_AUTO_BOT_ENABLED = "PREFILTER_AUTO_BOT_ENABLED";

export type TSetting = {
  key: string;
  value: string;
};

// Mismos valores que acepta FILTER_VALIDATE_BOOLEAN en el core, que es quien
// lee estos settings de tipo *_ENABLED. Si el setting no existe, está apagado.
const TRUTHY_SETTING_VALUES = ["1", "true", "on", "yes"];

export const isSettingEnabled = (setting: TSetting): boolean =>
  TRUTHY_SETTING_VALUES.includes(setting.value.trim().toLowerCase());

const apiGetSetting = async (key: string): Promise<TSetting> => {
  const res: TSetting = await apiEmpleo.get(`settings/${key}`);

  return res;
};

/**
 * Lee un setting que puede no estar configurado. Si la petición falla (404
 * porque el setting no existe) no se llama a `onValue`, de modo que el
 * llamante conserva su valor por defecto.
 */
export const loadOptionalSetting = async (
  key: string,
  onValue: (setting: TSetting) => void
): Promise<void> => {
  try {
    onValue(await apiGetSetting(key));
  } catch (e) {
    // El setting no está configurado.
  }
};

export { apiGetSetting };
